// Single source of truth for the site's public URL/identity, used in
// canonical tags, structured data (JSON-LD), and Open Graph meta.
//
// The live custom domain. If this ever changes, the matching values in
// index.html and public/robots.txt must be updated by hand too - those are
// static files that can't read this one. public/sitemap.xml regenerates
// from this value automatically via scripts/generate-sitemap.js on build.
// The old akhtar-sabir-shop.web.app address still serves the same site and
// is kept in the Worker's allowed origins as a fallback.
export const SITE_URL = 'https://akhtarsabirfresh.com'
export const SITE_NAME = 'Akhtar Sabir Fresh'

// Digits-only, no '+', per wa.me's format - used to build https://wa.me/
// links. Single source of truth: this used to be redeclared as a private
// constant inside Contact.jsx alone, which meant the floating WhatsApp
// button (WhatsAppButton.jsx) and the footer had no correct number to link
// to without duplicating it a second and third time.
export const WHATSAPP_NUMBER = '923000812894'
// Human-readable form for display (footer, Contact page) - kept alongside
// the digits-only version so the two can never drift out of sync.
export const WHATSAPP_DISPLAY = '+92 300 081 2894'
export const SHOP_PHONE_TEL = '+923432384440'
export const SHOP_PHONE_DISPLAY = '+92 343 238 4440'

// Real shop coordinates, taken from the Google Maps listing embedded in
// Footer.jsx ("Mohammad Akhtar and Sabir wholesale vegetable center") -
// the source of truth used to center the map in
// src/components/DeliveryLocationPicker.jsx. Real road-distance
// calculation happens server-side (see worker/src/routing.js and
// worker/src/distance.js, which is mirrored there since the Worker is a
// separate deployable and can't import from src/).
export const SHOP_LOCATION = { lat: 24.8142403, lng: 67.0364315 }

// Meta (Facebook/Instagram) Ads Pixel ID, from Meta Events Manager.
// Leave blank to keep the pixel inert - src/utils/metaPixel.js checks this
// and does nothing until a real ID is set here.
//
// Lives in its own dedicated "Akhtar & Sabir Fresh" Business Portfolio -
// the ampersand there is deliberate and NOT a leftover from the rename.
// That is the Meta asset's own name, which is separate from the site's
// "Akhtar Sabir Fresh" branding (SITE_NAME above, matched to the Google
// Business Profile). Renaming the portfolio is a separate decision.
// (previously used 753807259292544, an older pixel created directly under
// a personal account that Meta's newer Dataset system couldn't properly
// browse/select from within Ads Manager - this one was created fresh
// inside a proper Business Portfolio to avoid that).
export const META_PIXEL_ID = '1317704117104345'
// White-backed version of the logo - the raw "Brand Logo.png" has a
// transparent background, which blends into dark surfaces (browser tabs,
// dark-mode social previews). Use this one anywhere the logo needs to
// stand alone without a styled container behind it.
export const SITE_IMAGE = `${SITE_URL}/favicon.png`

// Cloudflare Worker that validates and creates orders server-side (see
// worker/src/index.js) - recomputes the real total from live Firestore
// prices instead of trusting whatever the browser sends. Points at a
// local `wrangler dev` server during development, the deployed Worker in
// production. Update the production URL once the Worker is deployed for
// real (it's assigned by Cloudflare based on the account's subdomain).
export const ORDER_WORKER_URL = import.meta.env?.DEV
  ? 'http://localhost:8787/place-order'
  : 'https://akhtar-sabir-orders.akhtar-sabir-fresh.workers.dev/place-order'

// Same Worker, /distance endpoint - real road-distance lookup (via
// LocationIQ) for the checkout map picker's live preview. Not
// authoritative on its own; /place-order independently re-verifies.
export const DISTANCE_CHECK_URL = import.meta.env?.DEV
  ? 'http://localhost:8787/distance'
  : 'https://akhtar-sabir-orders.akhtar-sabir-fresh.workers.dev/distance'
